import React, { useEffect, useState } from 'react'
import TopContainer from '../components/TopContainer'
import { getDefaultYearOption, getAreaChangeFromOption } from '../config/yearConfig'

import moment from 'moment';
import 'moment/locale/ko';

const MudHome = (props) => {
    const { location } = props;
    const menuId = location.state ? location.state.menuId : ''
    const initialMenu = menuId !== '' && menuId !== undefined ? menuId : 0
    const defaultYear = getDefaultYearOption(initialMenu)

    const [MenuId, setMenuId] = useState(initialMenu)
    const [YearUrl, setYearUrl] = useState(defaultYear.value)
    const [SelectedPrevYear, setSelectedPrevYear] = useState(defaultYear)
    const [SelectedPrevYearAreaChange, setSelectedPrevYearAreaChange] = useState(
        getAreaChangeFromOption(initialMenu)
    )

    useEffect(() => {
        const year = getDefaultYearOption(MenuId)
        setSelectedPrevYear(year)
        setYearUrl(year.value)
        setSelectedPrevYearAreaChange(getAreaChangeFromOption(MenuId))
    }, [MenuId])

    const handleMenuId = (menu) => {
        const year = getDefaultYearOption(menu)
        setMenuId(menu)
        setSelectedPrevYear(year)
        setSelectedPrevYearAreaChange(getAreaChangeFromOption(menu))
        getYearId(year.value)
    }

    const getYearId = (year) => {
        setYearUrl(year)
    }

    // selectbox 변경시 이벤트
    const handleSelectPrevYear = (year) => {
        setSelectedPrevYear(year)
        setSelectedPrevYearAreaChange(year)
        getYearId(year.value, MenuId)
    }

    return (
        <>
            <TopContainer menu={MenuId} handleMenuId={handleMenuId}
                YearUrl={YearUrl}
                // YearUrl={YearUrl} 
                getYearId={getYearId}
                SelectedPrevYear={SelectedPrevYear}
                handleSelectPrevYear={handleSelectPrevYear}
                SelectedPrevYearAreaChange={SelectedPrevYearAreaChange}
            />
        </>
    )
}

export default MudHome
